import { render, staticRenderFns } from "./EvidenceUpload.vue?vue&type=template&id=79702db2&scoped=true"
import script from "./EvidenceUpload.vue?vue&type=script&lang=ts"
export * from "./EvidenceUpload.vue?vue&type=script&lang=ts"
import style0 from "./EvidenceUpload.vue?vue&type=style&index=0&id=79702db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79702db2",
  null
  
)

export default component.exports